<template>
    <div class="portal-jzlpage-container" v-if="inited">
        <data-form :form-id="formId" :view-id="viewId" :form-code="formCode" :view-code="viewCode" :data-id="dataId"></data-form>
    </div>
</template>

<script>
    export default {
        props: [  ],
        data() {
            return {
                inited: false,
                loading: false,
                formId: null,
                viewId: null,
                formCode: null,
                viewCode: null,
                dataId: null,
                pageTitle: "��������"
            }
        },
        components: {

        },
        mounted () {
            this.init();
        },
        watch: {
            '$route' (to, from){
                this.init();
            },
        },
        computed: {

        },
        methods: {
            async init() {
                let formId = this.$route.query._fi || this.$route.query.formId;
                let viewId = this.$route.query._vi || this.$route.query.viewId;
                let formCode = this.$route.query._fc || this.$route.query.formCode;
                let viewCode = this.$route.query._vc || this.$route.query.viewCode;
                let dataId = this.$route.query._id || this.$route.query.dataId;

                this.loading = true;
                this.inited = false;
                this.formId = formId;
                this.viewId = viewId;
                this.formCode = formCode;
                this.viewCode = viewCode;
                this.dataId = dataId;

                // await this.refresh();

                this.loading = false;
                this.inited = true;

                // this.execDefault();
            },
            async refresh() {

            },
            execDefault() {

            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.portal-jzlpage-container {
    padding: 10px;
}
</style>
